import { API } from '../constants/api';

import { axiosInterceptor } from './interceptors';

export const listUpcomingOrder = async (payload: any) => {
    const response = await axiosInterceptor.get(`${API.DASHBOARD.UPCOMING}?${payload}`);

    return response;
};

export const listRecentActivity = async () => {
    const response = await axiosInterceptor.get(`${API.DASHBOARD.RECENT_ACTIVITY}`);

    return response;
};

export const listCustomerActivities = async (params: { page: number; limit: number; entityTypes?: string }) => {
    const response = await axiosInterceptor.get(`${API.CUSTOMER.ACTIVITIES}`, { params });

    return response;
};

export const listReviewItems = async (params: { page: number; limit: number; itemTypes?: string }) => {
    const response = await axiosInterceptor.get(`${API.CUSTOMER.REVIEW_ITEMS}`, { params });

    return response;
};

export const acknowledgeReviewItem = async (payload: { itemType: string; entityType: string; entityId: number; action?: string }) => {
    const response = await axiosInterceptor.post(`${API.CUSTOMER.ACKNOWLEDGE_REVIEW_ITEM}`, payload);

    return response;
};

// Marks a QUOTE_REVIEW/CUSTOMS_DOCUMENT review item or a Latest Activity row as seen —
// decrements the dashboard tab's badge count without removing it from its list.
export const markNotificationSeen = async (payload: { itemType: 'QUOTE_REVIEW' | 'CUSTOMS_DOCUMENT' | 'ACTIVITY'; entityId: number }) => {
    const response = await axiosInterceptor.post(`${API.CUSTOMER.MARK_NOTIFICATION_SEEN}`, payload);

    return response;
};
